import classNames from 'classnames'
import { ReactComponent as ZocksIcon } from '../../assets/ZocksIcon.svg'
import { IntegrationServiceId } from '../../common/integrations'
import { isSupportedMeetingProvider } from '../../common/meetingProviders'
import { IntegrationIcon } from '../../components/IntegrationIcon'
import styles from './CantJoinIntegrationIcon.module.scss'

interface CantJoinIntegrationIconProps {
  source?: string
}

export const CantJoinIntegrationIcon: React.FC<CantJoinIntegrationIconProps> = ({ source }) => {
  if (!source || !isSupportedMeetingProvider(source)) {
    return <ZocksIcon width={16} height={16} />
  }

  // Safe cast: isSupportedMeetingProvider narrows to 'zoom'|'teams'|'meet'|'webex',
  // which are the same string values as IntegrationServiceId.ZOOM/TEAMS/MEET/WEBEX.
  const serviceId = source as IntegrationServiceId

  return (
    <div className='position-relative'>
      <IntegrationIcon serviceId={serviceId} width={16} height={16} />
      <i className={classNames('bi bi-exclamation-triangle-fill text-danger position-absolute', styles.warningIcon)} />
    </div>
  )
}
